import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestDataArray } from 'src/types/requestData';
import { getRequest } from 'src/utils/request';

const mapCertificates = (attributes: UCM.CertificateRawType, id: string) => {
  return {
    id,
    label: attributes.title,
    value: attributes.code,
  };
};

const getCertificates = async () => {
  const { data } = await getRequest<RequestDataArray<UCM.CertificateRawType>>(
    API.GET.certificates,
  );
  return data?.data?.map(({ attributes, id }) =>
    mapCertificates(attributes, id),
  );
};

export const useGetCertificates = ({
  enabled = false,
}: {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CERTIFICATES],
    queryFn: () => getCertificates(),
    enabled,
  });
};
